import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import MachineStatusFilter from "./MachineStatusFilter";

const MachineStatus = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const [machineStatusEntries, setMachineStatusEntries] =
        useState(initialEntries);
    const [machineStatusPageIndex, setMachineStatusPageIndex] = useState(
        initialPage - 1
    );
    const [search, setSearch] = useState("");
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");
    const [dateFilter, setDateFilter] = useState("");

    const columns = [
        {
            accessor: "machine_name",
            header: "Machine Name",
            cell: (row) => <>{row?.machine?.machine_name}</>,
            filterable: true,
        },
        {
            accessor: "down_time",
            header: "Machine Down Time ( minutes )",
            cell: (row) => <>{row?.down_time?.toFixed(2)}</>,
        },
        {
            accessor: "up_time",
            header: "Machine Up Time ( minutes )",
            cell: (row) => <>{row?.up_time?.toFixed(2)}</>,
        },
        {
            accessor: "view",
            header: "Details",
            cell: (row) => (
                <button
                    className="btn btn-sm btn-primary"
                    onClick={() => {
                        navigate("/machine-details", { state: { data: row } });
                    }}
                >
                    View
                </button>
            ),
        },
    ];

    const { useFetch } = useAPIQuery({
        key: "machine_status",
        endpoint: "/api/machine_status/",
    });

    const { data, isLoading, isFetching } = useFetch({
        params: {
            entries: machineStatusEntries,
            page_no: machineStatusPageIndex + 1,
            action: "machine_status_report",
            q: globalFilterValue !== "" ? globalFilterValue : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const handleColumnFilterChange = (value) => {
        console.log(value);
        setColumnFilterKey(
            value
                .filter((item) => item.value)
                .map((item) => item.id)
                .join(",")
        );
        setColumnFilterValue(
            value
                .filter((item) => item.value)
                .map((item) => item.value)
                .join(",")
        );
    };

    const handlePagination = (value) => {
        console.log(value);
        setSearchParams({
            entries: value.pageSize,
            page: value.pageIndex + 1,
        });
        setMachineStatusPageIndex(value.pageIndex);
        setMachineStatusEntries(value.pageSize);
    };

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Machine Status
                        </h3>
                    </div>
                    {/* <div className="d-flex align-items-center justify-content-center ms-auto">
                        <button
                            className="btn btn-icon btn btn-outline-primary rounded-pill me-3"
                            data-bs-toggle="modal"
                            data-bs-target="#date-filter-modal"
                        >
                            <em className="icon ni ni-filter-fill" />
                        </button>
                    </div> */}
                </div>
            </div>

            <Table
                data={data ? data?.results.data : []}
                columns={columns}
                pagination
                pageIndex={machineStatusPageIndex}
                pageSize={machineStatusEntries}
                rowCount={data ? data.count : 0}
                globalSearch={false}
                isLoading={isLoading || isFetching}
                editRows={false}
                deleteRows={false}
                filterModal={false}
                selectRows={false}
                onColumnFilterChange={handleColumnFilterChange}
                onPaginationChange={handlePagination}
            />
            <MachineStatusFilter setFilter={setDateFilter} />
        </>
    );
};

export default MachineStatus;
